import IIAQDevicesState, { IIAQSensorFilter } from "../models/IIAQDevicesState";
import { sensorConfigJSONData } from "../reducers/data";

export const initialState: IIAQDevicesState = {
  iaqDevicesList: {
    data: {
      TotalRecords:0,
      TotalPages:1,
      CurrentPage:1,
      PageSize:100,
      IAQDevices:[]
    },
    error: null,
    loading: false,
    success: false,
  },
  iaqLegendDetailsVM:{
    data: [...sensorConfigJSONData],
    error: null,
    loading: false,
    success: false,
  },
  dashboardSensorsFilter:{
        sensor:null,
        error: null,
	      loading: false,
    },
};

export const filterInitialState: IIAQSensorFilter = {
    ICCID: '',
    CustomerId: '',
    Building: '',
    Floor: '',
    Room: '',
    Location: '',
    User: '',
    Comments: '',
    UserId: -1,
    SendMail: false,
    SensorType: 0, //Fixed typefor sensor iaq that is 0
    LatestPayloadStartDateTime: '',
    LatestPayloadEndDateTime: '',
}